import React, { ReactElement, useEffect, useState } from 'react';
import {
  Breadcrumbs,
  HiddenPriorityTitle,
  homeBreadcrumb,
  Message,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import { useClient } from '../../context/ClientStatusContext';
import { getVyhlasenieOPristupnosti } from '../../client/vyhlasenieOPristupnostiClient';
import VyhlasenieOPristupnosti from '../../module/VyhlasenieOPristupnosti';
import insertScripts from '../../function/insertScripts';

const VyhlasenieOPristupnostiPage = (): ReactElement => {
  const {
    data,
    status,
  } = useClient(
    () => getVyhlasenieOPristupnosti(),
  );
  const [displayError, setDisplayError] = useState(true);

  useEffect(() => {
    if (data) {
      insertScripts([
        `${process.env.REACT_APP_SUBPATH}js/linkHandler.js`,
      ]);
    }
  }, [data]);

  return (
    <Layout>
      <HiddenPriorityTitle>Vyhlásenie o prístupnosti</HiddenPriorityTitle>
      <Breadcrumbs
        routeList={[
          homeBreadcrumb(process.env.REACT_APP_STATICKY_OBSAH_URL as string),
          {
            to: routes.vyhlasenieOPristupnosti.to,
            heading: routes.vyhlasenieOPristupnosti.name,
          },
        ]}
      />
      <Loader loading={status.loading}>
        {(status.responseCode && status.responseCode > 399) ? (
          <>
            {displayError && (
              <Message
                type="error"
                onClear={() => setDisplayError(false)}
                headingSize="m"
              >
                Nepodarilo sa načítať vyhlásenie o prístupnosti.
              </Message>
            )}
          </>
        )
          : (
            <VyhlasenieOPristupnosti
              text={data}
            />
          )}
      </Loader>
    </Layout>
  );
};

export default VyhlasenieOPristupnostiPage;
